<script>
import {
  BModal,
  BTabs,
  BTab,
  BCard,
  VBTooltip,
  BCardText,
  BDropdown,
  BButtonGroup,
  BDropdownItem,
  BDropdownHeader,
  BSpinner
} from 'bootstrap-vue';
import dayjs from '../../core/dayjs';
import Swal from 'sweetalert2';
import TemperatureModal from './TemperatureModal.vue'
import ThinChevron from '../../components/icon/ThinChevron.vue';
import ActivityList from '../activity/List.vue'

export default {
  components: {
    ThinChevron,
    BModal,
    BButtonGroup,
    BTabs,
    BTab,
    BCard,
    BCardText,
    BDropdown,
    BDropdownItem,
    BDropdownHeader,
    BSpinner,
    TemperatureModal,
    ActivityList
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  props: ['user', 'pipelines', 'currentPipeline'],

  store: ['users'],

  mounted() {
    this.selectedPipeline = this.currentPipeline;

    this.$nextTick(() => {
      this.openHashData();

      window.onhashchange = () => this.openHashData();

      this.$root.$on('bv::modal::hide', (event, modalId) => {
        if (modalId == 'deal-modal') {
          this.close(false);
        }
      });

      this.updateCarouselArrows();
    });

    window.addEventListener('beforeunload', this.preventPageUnload);
    this.$refs['deal-modal'].$on('hide', this.handleModalClose);
    Bus.$on('close', () => this.handleModalClose());
    Bus.$on('open', (deal) => this.open(deal));
    Bus.$on('stagesRetrieved', (stages) => {
      this.stages = stages;
    });
    Bus.$on('listHeightUpdate', () => {
      let offsetHeight = 0;
      const el = document.getElementById('activity-list');

      if (el) {
        offsetHeight = el.offsetHeight;
      }

      this.customFieldsHeight = Math.max(offsetHeight, 200);
      this.originalTitle = this.deal.title;
      this.originalValue = this.deal.value;
    });

    Bus.$on('activityCreatedWithSchedule', () => {
      this.updateDealAndCalendar();
    });

    Bus.$on('activity-deleted', () => {
      this.updateDealAndCalendar();
    });

    this.getTypes();

    // Adicionar listeners para atualizar a posição
    window.addEventListener('scroll', this.updateTooltipPosition);
    window.addEventListener('resize', this.updateTooltipPosition);
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.preventPageUnload);
    // Remover listeners
    window.removeEventListener('scroll', this.updateTooltipPosition);
    window.removeEventListener('resize', this.updateTooltipPosition);
  },

  data() {
    return {
      deal: null,
      lead: null,
      stages: [],
      status: {
        names: {
          open: 'Aberto',
          closed: 'Ganho',
          lost: 'Perdido',
        },
      },
      stageName: '',
      customFieldsHeight: 200,
      loading: true,
      isLoading: false,
      types: [],
      hasUnsavedChanges:false,
      hasUnsavedChangesTitle:false,
      showTemperatureModal: false,
      showLeftArrow: false,
      showRightArrow: false,
      selectedPipeline: null,
      isHoveredActivities: false,
      isHoveredInformations: false,
      activeTab: 'informations'
    };
  },

  watch: {
    deal(deal, old) {
      // Skip if not updating
      if (deal && old) {
        this.hasUnsavedChangesTitle = false;
        Bus.$emit('updateCard', {
          card: deal,
          column: deal.stage_id,
        });
      }
    },

    users(users) {
      if (users) {
        this.openHashData();
      }
    },

    currentPipeline: {
      handler(newPipeline) {
        this.selectedPipeline = newPipeline;
      },
      immediate: true,
    }
  },

  computed: {
    leadCustomFields() {
      if (!this.deal.lead?.field_values) {
        return [];
      }

      return this.deal.lead?.field_values.filter(
        (value) => value.field.hidden === false && value.value != '',
      );
    },

    delayed() {
      const today = new Date();
      // eslint-disable-next-line camelcase
      const { expected_at } = this.deal;

      // eslint-disable-next-line camelcase
      return expected_at && today.getTime() > new Date(expected_at).getTime();
    },

    currentTemperature() {
      if (!this.deal || this.deal.temperature === null) {
        return 'cold';
      }

      return this.deal.temperature.temperature_label;
    },
    
    temperatureLabel() {
      const labels = {
        'cold': this.__('Frio'),
        'warm': this.__('Morno'),
        'hot': this.__('Quente')
      };
      return labels[this.currentTemperature];
    }
  },

  methods: {
    handleClose() {
      Bus.$emit('deal-modal-close');
    },
    stripHtml(html) {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || '';
    },
    onTemperatureSaved(temperature) {
      if (this.deal) {
        this.deal.temperature = {
          temperature_label: temperature
        };
      }
    },
    dealPipeline() {
      return this.pipelines.find((pipeline) => pipeline.stages.find((stage) => stage.id === this.deal.stage_id));
    },
     // Métodos para o comportamento do carousel
    scrollLeft() {
      const arrowWidth = 15;
      let scrollingWidth = 350;
      const carousel = document.getElementById('carousel');
      if (carousel) {
        if (carousel.scrollLeft - scrollingWidth * 2 < 0) {
          scrollingWidth = carousel.scrollLeft + arrowWidth;
        }
        carousel.scrollBy({ left: -scrollingWidth, behavior: 'smooth' });
      }
    },

    scrollRight() {
      const arrowWidth = 15;

      let scrollingWidth = 350;
      const carousel = document.getElementById('carousel');
      if (carousel.offsetWidth + carousel.scrollLeft + scrollingWidth * 2 > carousel.scrollWidth) {
        scrollingWidth = carousel.scrollWidth + arrowWidth - (carousel.offsetWidth + carousel.scrollLeft);
      }
      carousel.scrollBy({ left: scrollingWidth, behavior: 'smooth' });
      // const carousel = document.getElementById('carousel');
      // if (carousel) {
      //   carousel.scrollBy({ left: 100, behavior: 'smooth' });
      // }
    },

    updateCarouselArrows() {
      const carousel = document.getElementById('carousel');
      if (carousel) {
        const carouselScrollWidth = carousel.scrollWidth;
        this.showLeftArrow = carousel.scrollLeft > 0;
        this.showRightArrow = carousel.scrollLeft + carousel.clientWidth < carousel.scrollWidth;
      }
    },

    showStageName(stageNameId) {
      this.stageName = stageNameId;
    },

    hideStageName() {
      this.stageName = '';
    },

    onTitleChange(newValue) {
      if (newValue !== this.originalTitle) {
        this.hasUnsavedChangesTitle = true;
      } else {
        this.hasUnsavedChangesTitle = false;
      }
    },

    onValueChange(newValue) {
      if (newValue != this.originalValue) {
        this.hasUnsavedChangesTitle = true;
      } else {
        this.hasUnsavedChangesTitle = false;
      }
    },
    /**
     * Open the modal.
     */
     async open(deal) {
       this.$refs['deal-modal'].show();
       if (deal) {
         this.loading = true;
         const data = await this.$http.get(`deal/detail/${deal.hashid}?modal=true`);
        this.deal = data.body;
      }

      if (this.deal.lead && !this.deal.lead?.score) {
        this.setLeadScore();
      }

      history.pushState(null, null, `#/${this.deal.hashid}`);

      this.loading = false;

      this.$nextTick(() => {
        this.$nextTick(() => {
          this.updateCarouselArrows();
        });

        const sidebar = document.getElementById('modal-sidebar');
        if (sidebar) {
          new ResizeObserver(this.calculateModaMainContentHeight).observe(sidebar);
        }
        
      });
    },

    setLeadScore() {
      this.$http.get(`lead/${this.deal.lead?.hashid}/score`).then(({ data }) => {
        this.deal.lead.score = data.score;

        this.$forceUpdate();
      }).catch((error) => {
        console.error(error);
      });
    },

    handleUpdate(value) {
      this.deal.closed_at = `${value}`;
    },

    openHashData() {
      const { hash } = window.location;

      if (this.deal || !hash) {
        return;
      }

      this.$http
        .get(`/deal/detail/${hash.replace('#/', '')}`)
        .then(({ data }) => {
          this.deal = data;

          this.$nextTick(() => this.open());
        });
    },

    getTypes() {
      this.$http
        .get('/lead/activity/types')
        .then((response) => {
          this.types = response.data;
        })
        .catch((error) => {
          console.log(error.responseJSON);
        });
    },

    preventPageUnload(event) {
      if (this.hasUnsavedChanges || this.hasUnsavedChangesTitle) {
        event.preventDefault();
        event.returnValue = '';
      }
    },

    /**
     * Close the card modal.
     */
    close(force) {
      if (this.hasUnsavedChanges) {
        this.showConfirmationAlert(force);
      } else {
        this.closeModal(force);
      }
      this.isLoading = false;
    },

    handleModalClose(event) {
      if (this.hasUnsavedChanges) {
        event.preventDefault();
        this.showConfirmationAlert();
      }
    },

    showConfirmationAlert(force) {
      Swal.fire({
        iconHtml: '<img src="/build/icons/question-circle.svg" style="width: 72px; height: 72px;">',
        title: this.__('Deseja realmente sair?'),
        html: `
          <div class="container-basic mb-3">
            <span class="container-basic-title">${this.__('Existem alterações que não foram salvas.')}</span>
          </div>
        `,
        buttonsStyling: false,
        allowOutsideClick: false,
        confirmButtonText: this.__('Sair'),
        cancelButtonColor: 'transparent',
        cancelButtonText: this.__('Cancelar'),
        showCancelButton: true,
        customClass: {
          container: 'container-delete-lead',
          confirmButton: 'salesflow-btn salesflow-btn-secondary',
          cancelButton: 'btn swal2-btn-cancel-transparent swal2-btn-full-line',
          icon: 'no-border'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.hasUnsavedChanges = false;
          this.closeModal(force);
        }
      });
    },

    closeModal(force) {
      this.deal = null;
      this.activeTab = 'informations';
      history.pushState(null, null, window.location.pathname + window.location.search);

      if (force !== false) {
        this.$refs['deal-modal'].hide();
      }
      this.hasUnsavedChanges = false;
      this.hasUnsavedChangesTitle = false;
    },

    getUsers() {
      return this.users.map((user) => ({ value: user.id, text: user.name }));
    },

    markAs(status) {
      // if (status !== 'lost') {
      //   this.deal.status = status;
      // }

      Bus.$emit('markCardAs', [this.deal, status]);
    },

    move(fromId, toId) {
      this.deal.stage_id = toId;

      Bus.$emit('moveCard', [this.deal, fromId, toId]);
    },

    changeStage(stage) {
      this.isLoading = true;
      const oldStageId = this.deal.stage_id;

      if (oldStageId === stage.id) {
        this.isLoading = false;
        return;
      }

      this.deal.stage_id = stage.id;
      this.$http
        .put(`/deal/${this.deal.id}`, { stage_id: stage.id })
        .then(() => {
          Alert.success(this.__('Estágio alterado'));
          this.isLoading = false;
        })
        .catch(() => {
          Alert.error(this.__('Erro ao alterar o estágio do negócio'));
          this.isLoading = false;
          this.deal.stage_id = oldStageId;
        })
        .finally(() => {
          Bus.$emit('getBoard');
          const isThisStageOnTheSelectedPipeline = this.selectedPipeline.stages.find((selectedPipelineStage) => selectedPipelineStage.id === stage.id);

          // se meu estágio não está no pipeline atual, eu vou definir o pipeline atual encontrando o estágio dentre todos os pipelines recebidos
          if (!isThisStageOnTheSelectedPipeline) {
            this.pipelines.forEach((pipeline) => {
              if (pipeline.stages.find((selectedPipelineStage) => selectedPipelineStage.id === stage.id)) {
                this.selectedPipeline = pipeline;
                this.$forceUpdate();
              }
            });
          }

          this.isLoading = false;
        });
    },

    startDrag() {
      this.dragging = true;
    },

    endDrag() {
      this.dragging = false;
    },

    formatDate(date) {
      return dayjs(date).format('LDT');
    },

    calculateModaMainContentHeight() {
      const sidebar = document.getElementById('modal-sidebar');
      const mainContent = document.getElementById('modal-main-content');

      if (!sidebar) {
        return null;
      }

      const height = Math.max(sidebar.offsetHeight, 642)

      mainContent.style.height = `${height}px`;
    },

    onActivityChanged(content) {
      this.hasUnsavedChanges = content && content.trim() !== '';
    },

    onMessageChanged(content) {
      this.hasUnsavedChanges = content && content !== null;
    },

    openTemperatureModal() {
      if (this.deal.status === 'open') {
        this.$refs.temperatureModal.show()
      }
    },

    updateCalendarButtonVisibility() {
      const calendarBtn = document.querySelector('.btn-calendar');
      if (calendarBtn) {
        const hasActivitiesToday = this.deal?.lead?.activities?.some(activity => {
          const activityDate = new Date(activity.scheduled_at);
          const today = new Date();
          return activityDate.toDateString() === today.toDateString();
        });

        calendarBtn.style.display = (this.activeTab === 'activities' && hasActivitiesToday) ? '' : 'none';
      }
    },

    switchTab(tab) {
      this.activeTab = tab;
      this.updateCalendarButtonVisibility();
    },

    async updateDealAndCalendar() {
      const { data } = await this.$http.get(`deal/detail/${this.deal.hashid}?modal=true`);
      this.deal = data;
      this.updateCalendarButtonVisibility();
    },
  },
};
</script>

<template>
  <BModal
    id="deal-modal"
    ref="deal-modal"
    hide-footer="hide-footer"
    no-enforce-focus="no-enforce-focus"
    @hide="handleClose()"
  >
    <template slot="modal-header">
      <div class="modal-header-container" v-if="deal">
        <h4>
          <svg
            class="editable-input-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 15 15"
          >
            <g>
              <g>
                <path
                  d="M2.166 11.12l6.857-6.858 1.874 1.874L4.04 12.98l-1.888.014zm8.731-8.732l1.874 1.874-1.055 1.055-1.874-1.874zM1.014 10.87L1 13.577c0 .152.055.305.166.416.112.111.25.167.403.167l2.693-.014a.556.556 0 0 0 .403-.167l9.3-9.3a.587.587 0 0 0 0-.82L11.3 1.168a.587.587 0 0 0-.82 0L8.62 3.04l-7.44 7.426a.618.618 0 0 0-.166.403z"
                />
                <path
                  fill="none"
                  stroke="#f6f5f8"
                  stroke-miterlimit="50"
                  stroke-width=".3"
                  d="M2.166 11.12l6.857-6.858 1.874 1.874L4.04 12.98l-1.888.014zm8.731-8.732l1.874 1.874-1.055 1.055-1.874-1.874zM1.014 10.87L1 13.577c0 .152.055.305.166.416.112.111.25.167.403.167l2.693-.014a.556.556 0 0 0 .403-.167l9.3-9.3a.587.587 0 0 0 0-.82L11.3 1.168a.587.587 0 0 0-.82 0L8.62 3.04l-7.44 7.426a.618.618 0 0 0-.166.403z"
                />
              </g>
            </g>
          </svg>
          <InputEditable
            id="edit-title"
            type="text"
            field="title"
            v-model="deal"
            :title="__('Título do negócio')"
            :placeholder="__('Adicionar título')"
            :url="'/deal/' + deal.id"
            @field-changed-title="onTitleChange"
            class="modal-header-container__title"
          />
          <svg
            class="editable-input-icon value"
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 15 15"
          >
            <g>
              <g>
                <path
                  d="M2.166 11.12l6.857-6.858 1.874 1.874L4.04 12.98l-1.888.014zm8.731-8.732l1.874 1.874-1.055 1.055-1.874-1.874zM1.014 10.87L1 13.577c0 .152.055.305.166.416.112.111.25.167.403.167l2.693-.014a.556.556 0 0 0 .403-.167l9.3-9.3a.587.587 0 0 0 0-.82L11.3 1.168a.587.587 0 0 0-.82 0L8.62 3.04l-7.44 7.426a.618.618 0 0 0-.166.403z"
                />
                <path
                  fill="none"
                  stroke="#f6f5f8"
                  stroke-miterlimit="50"
                  stroke-width=".3"
                  d="M2.166 11.12l6.857-6.858 1.874 1.874L4.04 12.98l-1.888.014zm8.731-8.732l1.874 1.874-1.055 1.055-1.874-1.874zM1.014 10.87L1 13.577c0 .152.055.305.166.416.112.111.25.167.403.167l2.693-.014a.556.556 0 0 0 .403-.167l9.3-9.3a.587.587 0 0 0 0-.82L11.3 1.168a.587.587 0 0 0-.82 0L8.62 3.04l-7.44 7.426a.618.618 0 0 0-.166.403z"
                />
              </g>
            </g>
          </svg>
          <InputEditable
            id="edit-value"
            class="value"
            type="decimal"
            field="value"
            v-model="deal"
            :title="__('Valor do negócio')"
            :placeholder="__('Adicionar valor')"
            @field-changed-value="onValueChange"
            :url="'/deal/' + deal.id"
          />
        </h4>
        <span class="ml-auto modal-header__actions">
          <a
            class="salesflow-btn-box ml-3"
            href="#"
            @click.prevent="markAs('lost')"
            :class="{ active: deal.status === 'lost' }"
          >
            {{ __('Perdido') }}
            <svg
              class="lost ml-5px"
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              viewbox="0 0 9 9"
            >
              <g>
                <g>
                  <g>
                    <path
                      fill="#f6f5f8"
                      d="M8.393 1.962l-.219-.218-3.293 3.293-3.294-3.293-.219.218 3.294 3.294-3.294 3.293.22.22L4.88 5.474l3.293 3.293.22-.219L5.1 5.256z"
                    />
                    <path
                      fill="none"
                      stroke="#f6f5f8"
                      stroke-miterlimit="50"
                      d="M8.393 1.962v0l-.219-.218v0L4.881 5.037v0L1.587 1.744v0l-.219.218v0l3.294 3.294v0L1.368 8.549v0l.22.22v0L4.88 5.474v0l3.293 3.293v0l.22-.219v0L5.1 5.256v0z"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </a>
          <a
            class="salesflow-btn-box ml-3"
            href="#"
            @click.prevent="markAs('open')"
            :class="{ active: deal.status === 'open' }"
          >
            {{ __('Aberto') }}
            <svg
              class="open ml-5px"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewbox="0 0 12 10"
            >
              <g>
                <g>
                  <g>
                    <path
                      fill="#f6f5f8"
                      d="M11.186 9.045h-7.71a.575.575 0 1 1 0-1.15h7.71a.575.575 0 0 1 0 1.15z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#f6f5f8"
                      d="M11.186 5.434h-7.71a.575.575 0 1 1 0-1.15h7.71a.575.575 0 0 1 0 1.15z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#f6f5f8"
                      d="M11.186 1.823h-7.71a.575.575 0 1 1 0-1.15h7.71a.575.575 0 0 1 0 1.15z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#f6f5f8"
                      d="M.231 1.292a.773.773 0 1 1 1.545 0 .773.773 0 0 1-1.545 0z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#f6f5f8"
                      d="M.231 4.859a.773.773 0 1 1 1.545 0 .773.773 0 0 1-1.545 0z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#f6f5f8"
                      d="M.231 8.425a.773.773 0 1 1 1.545 0 .773.773 0 0 1-1.545 0z"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </a>
          <a
            class="salesflow-btn-box ml-3"
            href="#"
            @click.prevent="markAs('closed')"
            :class="{ active: deal.status === 'closed' }"
          >
            {{ __('Ganho') }}
            <svg
              class="won ml-5px"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewbox="0 0 13 13"
            >
              <g>
                <g>
                  <g>
                    <g>
                      <path
                        fill="#f6f5f8"
                        d="M11.935 6.47a5.348 5.348 0 0 1-5.343 5.343A5.348 5.348 0 0 1 1.25 6.47a5.348 5.348 0 0 1 5.342-5.342 5.348 5.348 0 0 1 5.343 5.342zm-11.872 0c0 3.6 2.93 6.53 6.53 6.53s6.529-2.93 6.529-6.53-2.93-6.529-6.53-6.529S.063 2.871.063 6.471z"
                      />
                    </g>
                    <g>
                      <path
                        fill="#f6f5f8"
                        d="M5.88 2.91v.695a1.783 1.783 0 0 0-1.187 1.679c0 .981.799 1.78 1.78 1.78a.594.594 0 0 1 0 1.187c-.253 0-.527-.159-.77-.449a.594.594 0 0 0-.909.764c.318.378.69.64 1.086.773v.693a.593.593 0 1 0 1.187 0v-.695a1.784 1.784 0 0 0 1.187-1.68c0-.981-.798-1.78-1.78-1.78a.594.594 0 0 1 0-1.187c.21 0 .432.107.642.31a.594.594 0 0 0 .825-.853 2.293 2.293 0 0 0-.874-.546v-.692a.594.594 0 1 0-1.187 0z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </a>
        </span>
        <BButtonGroup class="float-left dropdown-button move-to-dropdown ml-1">
          <BDropdown
            right
            no-caret
            variant="link"
            class="nav-action nav-profile"
            menu-class="bdk-deal-modal__dropdown"
            toggle-class="text-decoration-none p-0"
          >
            <template #button-content>
              <button
                id="options-button"
                class="btn"
                type="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <img
                  src="/build/icons/dropdown@white.svg"
                  alt="Menu"
                  width="5"
                  height="19"
                />
              </button>
            </template>

            <BDropdownHeader>
              {{ __('Mover para') }}
            </BDropdownHeader>

            <BDropdownItem :key="pipeline.id" v-for="(pipeline,i) in pipelines">
              <template v-if="pipeline.stages.length > 0">
                <div class="bdk-flex bdk-items-center">
                  {{ __(pipeline.name) }}

                  <i class="fa fa-angle-right bdk-ml-auto" />
                </div>

                <div class="bdk-group__list bdk-hidden">
                  <div
                    tabindex="-1"
                    :key="stage.name+stage.id+i"
                    class="dropdown-item"
                    v-text="__(stage.name)"
                    @click.prevent="changeStage(stage)"
                    v-for="stage in pipeline.stages"
                  />
                </div>
              </template>
            </BDropdownItem>
          </BDropdown>
        </BButtonGroup>
      </div>
      <div class="button-container">
        <button
          class="close"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          @click="close()"
        >
          <span aria-hidden="true">
            <img
              class="mb-5px"
              src="/build/icons/close@white.svg"
              alt="Perdido"
              width="16"
              height="16"
            />
          </span>
        </button>
      </div>
    </template>

    <template slot="default">
      <div v-if="loading" class="spinner-container">
        <BSpinner
          small
          class="spinner"
        />
      </div>
      <div class="m-0 row" v-else>
        <div id="modal-sidebar" class="modal-sidebar">
          <div class="d-flex justify-content-center mb-2 mt-3">
            <div class="btn-group">
              <button 
                class="btn btn-switch" 
                :class="{ active: activeTab === 'informations' }"
                @click="switchTab('informations')"
                @mouseenter="isHoveredInformations = true;"
                @mouseleave="isHoveredInformations = false"
                data-target="informations"
              >
                {{ __('Informações') }}
              </button>
              <div v-show="isHoveredInformations" class="tooltip-container-informations">
                  <div class="tooltip-arrow"></div>
                  <div class="tooltip-content py-2">
                      <p class="color-white m-0 weight-500">{{ __("Informações do lead") }}</p>
                  </div>
              </div>
                  <button
                class="btn btn-switch" 
                :class="{ active: activeTab === 'activities' }"
                @click="switchTab('activities')"
                @mouseenter="isHoveredActivities = true;"
                @mouseleave="isHoveredActivities = false"
                data-target="activities"
              >
                {{ __('Atividades') }}
                  </button>
              <div v-show="isHoveredActivities" class="tooltip-container">
                <div class="tooltip-arrow"></div>
                <div class="tooltip-content">
                  <p class="mb-2 color-white"><strong>{{ __("Atividades agendadas para hoje") }}</strong></p>
                  <p class="mb-0">{{ __('Aqui você visualiza as próximas atividades agendadas para este negócio, para ver todos os agendamentos clique em "ver no calendário".') }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="actions informations" :class="{ 'd-none': activeTab !== 'informations' }">
            <div>
              <div class="profile-detail">
                <table>
                  <tr>
                    <td><i class="fa fa-eye" /></td>
                    <td>
                      <a :href="'/lead/' + deal.lead?.hashid" target="_blank">
                        {{ __('Ver perfil') }}
                      </a>
                    </td>
                  </tr>
                  <tr v-if="deal.lead?.city || deal.lead?.state">
                    <td>
                      <img
                        class="mr-3px"
                        src="/build/icons/location.svg"
                        alt="Location"
                        width="15"
                        height="13"
                      />
                    </td>
                    <td>
                      <span v-if="deal.lead?.city">
                        {{ stripHtml(deal.lead?.city).substring(0, 130) }}
                        <span
                          v-if="deal.lead?.city && deal.lead?.state"
                          class="bdk-text-muted"
                        >
                          ,
                        </span>
                      </span>
                      <span v-if="deal.lead?.state">
                      {{ stripHtml(deal.lead?.state).substring(0, 130) }}</span>
                    </td>
                  </tr>
                  <tr v-if="deal.lead?.document">
                    <td>
                      <img
                        class="mb-3px mr-5px"
                        src="/build/icons/book.svg"
                        width="15"
                        height="14"
                        alt="Empresa"
                      />
                    </td>
                    <td>
                      {{ __('CPF / CNPJ') }}
                      <strong class="text-break">{{ deal.lead?.document }}</strong>
                    </td>
                  </tr>
                  <tr v-if="users">
                    <td>
                      <svg
                        class="mb-3px"
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="14"
                        viewbox="0 0 15 14"
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                fill="#3b334a"
                                d="M7.617 1.878a2.487 2.487 0 0 1 2.48 2.48 2.487 2.487 0 0 1-2.48 2.48 2.487 2.487 0 0 1-2.48-2.48 2.487 2.487 0 0 1 2.48-2.48zm0 5.849a3.37 3.37 0 0 0 3.368-3.369A3.36 3.36 0 0 0 7.617 1a3.367 3.367 0 0 0-3.369 3.358 3.376 3.376 0 0 0 3.369 3.369z"
                              />
                              <path
                                fill="none"
                                stroke="#3b334a"
                                stroke-miterlimit="50"
                                stroke-width=".2"
                                d="M7.617 1.878a2.487 2.487 0 0 1 2.48 2.48 2.487 2.487 0 0 1-2.48 2.48 2.487 2.487 0 0 1-2.48-2.48 2.487 2.487 0 0 1 2.48-2.48zm0 5.849a3.37 3.37 0 0 0 3.368-3.369A3.36 3.36 0 0 0 7.617 1a3.367 3.367 0 0 0-3.369 3.358 3.376 3.376 0 0 0 3.369 3.369z"
                              />
                            </g>
                            <g>
                              <path
                                fill="#3b334a"
                                d="M5.57 9.204h4.134c1.694 0 3.09 1.26 3.306 2.894H2.264a3.344 3.344 0 0 1 3.307-2.894zM1.79 12.986h11.697a.441.441 0 0 0 .444-.444 4.231 4.231 0 0 0-4.226-4.226H5.57a4.231 4.231 0 0 0-4.227 4.226c0 .248.197.444.445.444z"
                              />
                              <path
                                fill="none"
                                stroke="#3b334a"
                                stroke-miterlimit="50"
                                stroke-width=".2"
                                d="M5.57 9.204h4.134c1.694 0 3.09 1.26 3.306 2.894H2.264a3.344 3.344 0 0 1 3.307-2.894zM1.79 12.986h11.697a.441.441 0 0 0 .444-.444 4.231 4.231 0 0 0-4.226-4.226H5.57a4.231 4.231 0 0 0-4.227 4.226c0 .248.197.444.445.444z"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </td>
                    <td>
                      {{ __('Dono do Negócio') }}
                      <strong>
                        <InputEditable
                          type="select"
                          :options="getUsers()"
                          field="user_id"
                          :display-text="deal.user ? deal.user.name : ''"
                          :placeholder="__('Selecione')"
                          v-model="deal"
                          title="Dono do negócio"
                          :url="'/deal/' + deal.id"
                        />
                      </strong>
                    </td>
                  </tr>
                  <tr v-if="deal.status === 'open'">
                    <td>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewbox="0 0 16 16"
                      >
                        <g>
                          <g>
                            <g>
                              <g>
                                <path
                                  fill="#3b334a"
                                  d="M13.77 12.388a1.43 1.43 0 0 1-1.434 1.434H3.128a1.43 1.43 0 0 1-1.434-1.434v-6.24h12.09v6.24zM12.336 1.975h-1.32v-.588A.386.386 0 0 0 10.63 1a.386.386 0 0 0-.387.387V3.41a.754.754 0 0 0-.387.66c0 .43.344.775.774.775.43 0 .775-.345.775-.775 0-.287-.158-.516-.388-.66v-.66h1.32a1.43 1.43 0 0 1 1.434 1.435v1.19H1.694v-1.19c0-.789.645-1.434 1.434-1.434h.674v-.775h-.674A2.21 2.21 0 0 0 .919 4.184v8.204c0 1.219.99 2.209 2.209 2.209h9.208a2.21 2.21 0 0 0 2.209-2.21V4.185a2.21 2.21 0 0 0-2.21-2.209z"
                                />
                                <path
                                  fill="none"
                                  stroke="#3b334a"
                                  stroke-miterlimit="50"
                                  stroke-width=".3"
                                  d="M13.77 12.388a1.43 1.43 0 0 1-1.434 1.434H3.128a1.43 1.43 0 0 1-1.434-1.434v-6.24h12.09v6.24zM12.336 1.975h-1.32v-.588A.386.386 0 0 0 10.63 1a.386.386 0 0 0-.387.387V3.41a.754.754 0 0 0-.387.66c0 .43.344.775.774.775.43 0 .775-.345.775-.775 0-.287-.158-.516-.388-.66v-.66h1.32a1.43 1.43 0 0 1 1.434 1.435v1.19H1.694v-1.19c0-.789.645-1.434 1.434-1.434h.674v-.775h-.674A2.21 2.21 0 0 0 .919 4.184v8.204c0 1.219.99 2.209 2.209 2.209h9.208a2.21 2.21 0 0 0 2.209-2.21V4.185a2.21 2.21 0 0 0-2.21-2.209z"
                                />
                              </g>
                              <g>
                                <path
                                  fill="#3b334a"
                                  d="M4.089 9.333h.645a.832.832 0 0 0 0-1.664H4.09a.832.832 0 0 0-.832.832.842.842 0 0 0 .832.832z"
                                />
                                <path
                                  fill="none"
                                  stroke="#3b334a"
                                  stroke-miterlimit="50"
                                  stroke-width=".3"
                                  d="M4.089 9.333v0h.645a.832.832 0 0 0 0-1.664H4.09a.832.832 0 0 0-.832.832.842.842 0 0 0 .832.832z"
                                />
                              </g>
                              <g>
                                <path
                                  fill="#3b334a"
                                  d="M7.416 9.333h.646a.832.832 0 0 0 0-1.664h-.646a.832.832 0 0 0 0 1.664z"
                                />
                                <path
                                  fill="none"
                                  stroke="#3b334a"
                                  stroke-miterlimit="50"
                                  stroke-width=".3"
                                  d="M7.416 9.333h.646a.832.832 0 0 0 0-1.664h-.646a.832.832 0 0 0 0 1.664z"
                                />
                              </g>
                              <g>
                                <path
                                  fill="#3b334a"
                                  d="M10.744 9.333h.645a.832.832 0 0 0 0-1.664h-.645a.832.832 0 0 0 0 1.664z"
                                />
                                <path
                                  fill="none"
                                  stroke="#3b334a"
                                  stroke-miterlimit="50"
                                  stroke-width=".3"
                                  d="M10.744 9.333h.645a.832.832 0 0 0 0-1.664h-.645a.832.832 0 0 0 0 1.664z"
                                />
                              </g>
                              <g>
                                <path
                                  fill="#3b334a"
                                  d="M4.089 12.273h.645a.832.832 0 0 0 0-1.664H4.09a.832.832 0 0 0-.832.832.842.842 0 0 0 .832.832z"
                                />
                                <path
                                  fill="none"
                                  stroke="#3b334a"
                                  stroke-miterlimit="50"
                                  stroke-width=".3"
                                  d="M4.089 12.273v0h.645a.832.832 0 0 0 0-1.664H4.09a.832.832 0 0 0-.832.832.842.842 0 0 0 .832.832z"
                                />
                              </g>
                              <g>
                                <path
                                  fill="#3b334a"
                                  d="M7.416 12.273h.646a.832.832 0 0 0 0-1.664h-.646a.832.832 0 0 0 0 1.664z"
                                />
                                <path
                                  fill="none"
                                  stroke="#3b334a"
                                  stroke-miterlimit="50"
                                  stroke-width=".3"
                                  d="M7.416 12.273h.646a.832.832 0 0 0 0-1.664h-.646a.832.832 0 0 0 0 1.664z"
                                />
                              </g>
                              <g>
                                <path
                                  fill="#3b334a"
                                  d="M10.744 12.273h.645a.832.832 0 0 0 0-1.664h-.645a.832.832 0 0 0 0 1.664z"
                                />
                                <path
                                  fill="none"
                                  stroke="#3b334a"
                                  stroke-miterlimit="50"
                                  stroke-width=".3"
                                  d="M10.744 12.273h.645a.832.832 0 0 0 0-1.664h-.645a.832.832 0 0 0 0 1.664z"
                                />
                              </g>
                              <g>
                                <path
                                  fill="#3b334a"
                                  d="M4.835 4.83c.43 0 .774-.345.774-.775 0-.287-.158-.516-.387-.66v-.66h4.389v-.76H5.222v-.588A.386.386 0 0 0 4.835 1a.386.386 0 0 0-.388.387V3.41a.754.754 0 0 0-.387.66c0 .416.344.76.775.76z"
                                />
                                <path
                                  fill="none"
                                  stroke="#3b334a"
                                  stroke-miterlimit="50"
                                  stroke-width=".3"
                                  d="M4.835 4.83c.43 0 .774-.345.774-.775 0-.287-.158-.516-.387-.66v-.66 0h4.389v0-.76 0H5.222v0-.588A.386.386 0 0 0 4.835 1a.386.386 0 0 0-.388.387V3.41a.754.754 0 0 0-.387.66c0 .416.344.76.775.76z"
                                />
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                    </td>
                    <td>
                      {{ __('Fechamento Esperado') }}
                      <strong>
                        <InputEditable
                          type="date"
                          field="expected_at"
                          placeholder="Selecione"
                          v-model="deal"
                          title="Fechamento esperado"
                          :url="'/deal/' + deal.id"
                        />
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewbox="0 0 15 15"
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                fill="#3b334a"
                                d="M12.85 3.595l-.512.512-2.275-2.275.513-.512a1.207 1.207 0 0 1 1.707 0l.567.567a1.21 1.21 0 0 1 0 1.708zM1.873 10.48l1.817 1.818-2.513.696zm.454-.911L9.38 2.515l2.275 2.275-7.053 7.053zM12.967.637a2.174 2.174 0 0 0-3.074 0L1.275 9.255a.483.483 0 0 0-.124.212L.018 13.56a.483.483 0 0 0 .594.594l4.091-1.133a.483.483 0 0 0 .213-.124l8.618-8.618a2.176 2.176 0 0 0 0-3.074z"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </td>
                    <td v-b-tooltip.bottom="formatDate(deal.created_at)">
                      {{ __('Negócio cadastrado') }}
                      <strong>{{ deal.created_at | ago }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="15"
                        viewbox="0 0 16 15"
                      >
                        <g>
                          <g>
                            <g>
                              <path
                                fill="#3b334a"
                                d="M14.519 10.428a.522.522 0 0 0-.658-.335l-.679.22c.416-.86.634-1.805.634-2.771a6.377 6.377 0 0 0-6.37-6.37 6.377 6.377 0 0 0-6.37 6.37 6.377 6.377 0 0 0 6.37 6.37.522.522 0 0 0 0-1.044A5.332 5.332 0 0 1 2.12 7.542a5.332 5.332 0 0 1 5.326-5.326 5.332 5.332 0 0 1 4.794 7.647l-.232-.714a.522.522 0 0 0-.993.323l.616 1.895a.522.522 0 0 0 .658.335l1.895-.616a.522.522 0 0 0 .335-.658z"
                              />
                              <path
                                fill="none"
                                stroke="#3b334a"
                                stroke-miterlimit="50"
                                stroke-width=".6"
                                d="M14.519 10.428a.522.522 0 0 0-.658-.335l-.679.22c.416-.86.634-1.805.634-2.771a6.377 6.377 0 0 0-6.37-6.37 6.377 6.377 0 0 0-6.37 6.37 6.377 6.377 0 0 0 6.37 6.37.522.522 0 0 0 0-1.044A5.332 5.332 0 0 1 2.12 7.542a5.332 5.332 0 0 1 5.326-5.326 5.332 5.332 0 0 1 4.794 7.647l-.232-.714a.522.522 0 0 0-.993.323l.616 1.895a.522.522 0 0 0 .658.335l1.895-.616a.522.522 0 0 0 .335-.658z"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </td>
                    <td v-b-tooltip.bottom="formatDate(deal.updated_at)">
                      {{ __('Última Atualização') }}
                      <strong>{{ deal.updated_at | ago }}</strong>
                    </td>
                  </tr>
                  <tr v-if="deal.status === 'closed'">
                    <td>
                      <i class="fa fa-calendar" style="color: black" />
                    </td>
                    <td>
                      {{ __('Data do fechamento') }}
                      <strong>
                        <InputEditable
                          type="date"
                          field="date"
                          :value="deal.closed_at"
                          :url="'/deal/' + deal.id"
                          @update="handleUpdate"
                        />
                      </strong>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <hr
              v-if="
                deal.lead && leadCustomFields && leadCustomFields.length > 0
              "
            />

            <div
              class="profile-detail scroll"
              :style="{ 'max-height': customFieldsHeight + 'px' }"
            >
              <div
                class="pb-2"
                v-for="value in leadCustomFields"
                :key="value.id"
              >
                <span class="text-break">{{ value.field.description }}:</span>
                <strong class="text-break" v-if="value.field.identifier === 'whatsapp' && deal.lead?.whatsapp_int">
                  <br />
                  <a
                    target="_blank"
                    :href="
                      'https://api.whatsapp.com/send?phone=' +
                      deal.lead?.whatsapp_int.replace('+', '')
                    "
                  >
                    <i class="fa fa-whatsapp" />
                    {{ __('Abrir Conversa') }}
                    <i class="fa fa-external-link" />
                  </a>
                </strong>
                <strong class="text-break" v-else v-html="value.html_value" />
              </div>
            </div>
          </div>
          <div class="activities" :class="{ 'd-none': activeTab !== 'activities' }">
            <ActivityList :hash="deal.lead.hashid" :isDealModal="true" />
          </div>
          <div class="d-flex justify-content-center my-3">
            <a 
              href="/calendar" 
              class="btn-calendar"
              style="display: none;"
            >
              <span>{{ __('Ver no calendário') }}</span>
            </a>
          </div>
        </div>
        <div id="modal-main-content" class="bg-salesflow-bg-content modal-main-content">
          <div class="content">
            <div id="lead-data-section" class="d-flex align-items-center justify-content-start gap-4-5">
              <Avatar
                class="rounded-circle avatar-md avatar-size"
                :name="deal.lead?.name || deal.lead?.email"
                width="128"
                :url="deal.lead?.gravatar"
              />
              <div class="d-flex flex-column justify-content-start align-items-start">
                <div class="profile-name">
                  <h3 class="title">
                    {{ deal.lead?.name }}
                  </h3>
                  <LeadScore
                    v-if="deal &amp;&amp; deal.lead &amp;&amp; deal.lead?.score"
                    :score="deal.lead?.score"
                    :points="deal.lead?.points"
                  />
                </div>
                <div class="mb-1">
                  <LeadOpportunity
                    :hash="deal.lead?.hashid"
                    :opportunity="deal.lead?.opportunity"
                    custom-class="mr-1"
                    show="show"
                  />
                </div>
                <div class="contact-info" v-if="deal.lead?.email">
                  <img
                    class="mr-3px"
                    src="/build/icons/envelope-straight.svg"
                    alt="Envelope"
                    width="15"
                    height="13"
                  />
                  {{ deal.lead?.email }}
                </div>
                <div class="contact-info" v-if="deal.lead?.phone">
                  <LeadIntegrationClickToCall />
                  <LeadClickToCall
                    :hash="deal.lead?.hashid"
                    :phones="deal.lead?.phone.toString().split(',')"
                    :valid-phones="deal.lead?.valid_phone.split(',')"
                    :user="user"
                    round-icon="round-icon"
                  />
                </div>
                <div v-if="deal.lead?.whatsapp_int">
                  <a
                    :href="
                      'https://api.whatsapp.com/send?phone=' +
                      deal.lead?.whatsapp_int.replace('+', '')
                    "
                    target="_blank"
                  >
                    <i class="fa fa-whatsapp" />
                    {{ __('Abrir Whatsapp') }}
                    <i class="fa fa-external-link" />
                  </a>
                </div>
              </div>
              <a data-ignore-unsaved-check href="#" 
                 :class="[
                   'button-temperature',
                   `button-${currentTemperature}`,
                   { 'disabled': deal.status !== 'open' }
                 ]" 
                 @click.prevent="openTemperatureModal"
              >
                <img :src="`/build/icons/${currentTemperature}-icon.svg`" />
                <label :class="`label-${currentTemperature} label-temperature`">
                  {{ temperatureLabel }}
                </label>
              </a>
            </div>
            <div id="funnel-picker-section" class="pt-4-5 d-flex justify-content-between align-items-center">
              <button v-if="showLeftArrow" id="left-arrow" class="carousel-arrow left w-fit-content position-absolute left-0 z-index-1000 px-3 py-2-5 rounded-circle bg-light-gray" @click="scrollLeft">
                <ThinChevron :direction="'left'" />
              </button>
              <div 
                id="carousel" 
                class="carousel-container d-flex pl-0" 
                :class="[ 
                  showLeftArrow && showRightArrow 
                    ? 
                      'col-11 mx-auto' 
                    : 
                      showLeftArrow && !showRightArrow 
                        ? 
                          'col-11 ml-auto' 
                        : 
                          !showLeftArrow && showRightArrow
                            ? 
                              'col-12 mr-auto' 
                            : 
                              'col-12'
                ]"
                @scroll="updateCarouselArrows"
              >
                <div v-for="(stage, index) in dealPipeline()?.stages" :key="stage.name+stage.id+index" class="stage-item"  @mouseover="showStageName(stage.name+stage.id)" @mouseleave="hideStageName" >
                  <button
                    @click="changeStage(stage)" 
                    :disabled="isLoading" 
                    class="d-flex align-items-center border-0 bg-ice-white arrow-polygon-format lh-18 fs-8 py-1-5 px-3 min-width-16" 
                    :class="[stage.id === deal.stage_id ? 'bg-custom-purple text-white min-width-150 gap-2-5 pl-4 justify-content-start' : 'button-hover-custom']"
                  >
                    <span class="fw-700 min-width-16" :class="[ stage.id !== deal.stage_id && stageName !== stage.name+stage.id ? 'text-purple' : 'text-white' ]">
                      {{ index >= 9 ? index + 1 : '0' + (index + 1) }}
                    </span>
                    <span v-if="stage.id === deal.stage_id || stageName === stage.name+stage.id">
                      <div v-if="stage.name.length > 30">
                        <tooltip
                          :title="stage.name"
                          tooltipClass="stage-tooltip"
                          triggers="hover"
                          :placement="'bottom'"
                          :boundary="'viewport'"
                      >
                          {{ stage.name | truncate(30) }}
                        </tooltip>
                      </div>
                      <div v-else>
                        {{ stage.name }}
                      </div>
                    </span>
                    <span v-if="isLoading && stage.id === deal.stage_id"> 
                      <i class="fa fa-spinner fa-spin" />
                    </span>
                  </button>
                </div>
                <div id="filler-container" class="min-width-150">

                </div>
              </div>
              <button v-if="showRightArrow" id="right-arrow" class="carousel-arrow right w-fit-content position-absolute left-800 z-index-1000 px-3 py-2-5 rounded-circle bg-light-gray" @click="scrollRight">
                 <ThinChevron :direction="'right'" />
              </button>
            </div>
            <div>
              <BCard no-body>
                <BTabs>
                  <BTab :title="__('Atividade')" active>
                    <BCardText>
                      <LeadActivity
                        :deal="deal"
                        :user="user"
                        :types="types"
                        :hash="deal.lead?.hashid"
                        @activity-changed="onActivityChanged"
                      />
                    </BCardText>
                  </BTab>
                  <BTab :title="__('Mensagens')">
                    <BCardText>
                    <LeadMessage
                      :user="user"
                      :hash="deal.lead?.hashid"
                      @message-changed="onMessageChanged"
                    />
                    </BCardText>
                  </BTab>
                </BTabs>
              </BCard>
            </div>
          </div>
        </div>
      </div>
      <lead-docs-modal v-if="deal && deal.lead && deal.lead.hashid" :hash="deal.lead.hashid"></lead-docs-modal>
      <lead-media-modal v-if="deal && deal.lead && deal.lead.hashid" :lead-hash-id="deal.lead.hashid"></lead-media-modal>
      <lead-file-modal v-if="deal && deal.lead && deal.lead.hashid"></lead-file-modal>
    </template>

    <TemperatureModal 
      v-if="deal"
      ref="temperatureModal"
      :deal-id="deal?.id"
      :initial-temperature="deal?.temperature?.temperature_label"
      @temperature-saved="onTemperatureSaved"
    />
  </BModal>
</template>

<style lang="scss">
@import '../../../sass/variables';

.text-purple {
  color: #886AF8 !important;
}

.bg-ice-white {
  background-color: #F8FAFC !important;
}

.bg-custom-purple {
  background-color: #886AF8 !important;
}

// .bg-custom-purple:hover {
//   background-color: #5F33FF !important;
// }

.arrow-polygon-format {
  clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 50%, calc(100% - 10px) 100%, 0 100%, 10px 50%);
}

.lh-18 {
  line-height: 18px;
}

.fs-8 {
  font-size: 12px;
}

.fw-700 {
  font-weight: 700;
}

.gap-2-5 {
  gap: 10px;
}

.min-width-16 {
  min-width: 16px;
}

.min-width-150 {
  min-width: 150px;
  transition: min-width 2s ease;
}

.py-1-5 {
  padding-top: 6px;
  padding-bottom: 6px;
}

.py-2-5 {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}

.gap-4-5 {
  gap: 32px;
}

.pt-4-5 {
  padding-top: 32px;
}

.bg-light-gray {
  background-color: #e4e4e4 !important;
}

.bg-light-gray:hover {
  background-color: #d1d1d1 !important;
}

#deal-modal {
  #options-button {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .spinner-container {
    background-color: $salesflow-bg-content;
    height: 515px;
    padding-left: 24px;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .spinner {
    position: static !important;
    color: $salesflow-primary;
  }

  .button-container {
    margin-left: auto;
    margin-right: 24px;
  }

  .modal-dialog {
    width: 100%;
    max-width: 1100px;
    color: $salesflow-font-dark;
    border-radius: 16px;

    .salesflow-btn {
      margin-top: 8px;
      padding: 8px 24px;
    }

    .modal-header {
      border: none;
      display: flex;
      align-items: center;
      background-color: $salesflow-primary;
      vertical-align: middle;
      padding: 0px;
      min-height: 56px;
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;

      &__actions {
        display: flex;
        flex-shrink: 0;

        .btn {
          margin-bottom: 0px !important;
        }

        a:not(.active):hover {
          color: $white;
        }
      }

      .modal-header-container {
        width: 100%;
        display: flex;
        align-items: center;
        fill: $salesflow-bg-content !important;
        padding: 12px 0px 12px 24px;

        #edit-value .editable-click {
          font-weight: 800;
        }

        &__title {
          .editable-click {
            max-width: 394px !important;
            font-weight: 800;
          }
        }

        div {
          width: auto;
        }

        h4 {
          display: flex;
          align-items: center;
          margin-bottom: 0px;
          color: $salesflow-bg-content;
          font-size: 0.875rem;
          font-weight: 800;
          letter-spacing: -0.2px;
          line-height: 150%;
          text-transform: uppercase;

          .editable {
            margin: 0px;
            align-items: center;

            .editable-click {
              margin: 0px;
              overflow: hidden;
              font-style: normal;
              white-space: nowrap;
              letter-spacing: -0.2px;
              text-overflow: ellipsis;
              text-transform: uppercase;
            }
          }

          .value {
            margin-right: 8px;

            .editable {
              margin-left: 5px;

              .editable-click {
                padding-bottom: 2px;
              }
            }
          }

          svg.value {
            margin-left: 2.5vw;
          }

          .editable-input-icon {
            margin-right: 0.6vw;
            padding-top: 2px;
          }
        }

        .salesflow-btn-box.active {
          background-color: $salesflow-bg-content;
          color: $salesflow-primary;

          svg.lost {
            path:nth-child(1) {
              fill: $salesflow-primary;
            }

            path:nth-child(2) {
              stroke: $salesflow-primary;
            }
          }

          svg.open,
          svg.won {
            path {
              fill: $salesflow-primary;
            }
          }
        }

        .dropdown-button {
          top: 4px;
          height: 37px;
          position: relative;

          button {
            border: 0px;
            height: 100%;
          }
        }

        .close {
          padding: 0px;
          margin-right: 24px;
          margin: 0px;
          opacity: 0.9;
        }

        .move-to-dropdown {
          .multiselect__content-wrapper {
            width: auto;
            display: none;
            padding: 0px;
            left: -117px !important;
            overflow: visible;
            margin-top: -1px;
            border-radius: 15px 0px 0px 15px;
            max-height: unset;

            .multiselect__element:hover {
              color: #3b334a;
              background: #eae6f0;
            }

            .dropdown-header {
              color: #7123db;
              font-size: 13px;
              font-weight: 700;
              letter-spacing: -0.2px;
              background-color: white;
              border-radius: 15px 0px 0px;

              &:hover {
                background-color: white;
                color: #7123db;
              }
            }

            .multiselect__option:hover {
              text-decoration: none;
            }

            .menu-primario.multiselect__element:last-child:hover {
              border-radius: 0px 0px 0px 15px;
            }

            .dropdown-submenu:hover {
              .multiselect__content-wrapper {
                display: block;
                border-radius: 0px 15px 15px 0px;
                overflow: hidden;
                left: 159px !important;
                margin-top: 0px;
                background: #eae6f0;
                box-shadow: 10px 10px 20px rgba(103, 70, 162, 0.18);
                top: 0px;

                &::before {
                  border: none;
                }

                .multiselect__element:hover {
                  color: #3b334a;
                  background: #f6f5f8;
                }
              }
            }
          }

          .multiselect__content-wrapper:before {
            margin-top: -9px;
            margin-left: 108px;
            border-bottom-color: white;
          }

          margin-top: -5px;
          margin-left: 108px;

          .multiselect__content-wrapper.show {
            display: block;
          }
        }
      }
    }

    .modal-main-content {
      width: 79%;
      overflow-y: scroll;
      border-right: 4px solid transparent;
      padding: 24px 16px 0px;
      border-bottom-right-radius: 16px;
      background-color: #F5F5F5 !important;
      position: relative;
      z-index: 1; // Mantendo z-index baixo
    }

    .modal-sidebar {
      width: 21%;
      overflow-y: hidden;
      overflow-x: hidden;
      color: $salesflow-font-dark;
      font-size: 0.75rem;
      line-height: 125%;
      font-weight: 400;
      display: flex;
      flex-direction: column;
      align-items: center;
      border: 1px solid $salesflow-outline-gray-medium;
      border-bottom-left-radius: 16px;
      background-color: #FFF;
    }

    .modal-content {
      background-color: transparent;
      border-radius: 16px;

      .modal-body {
        min-height: 380px;
        padding: 0px;
        background-color: transparent;

        .col-left {
          z-index: 2;
          padding-left: 20px;
          padding-right: 30px;
        }

        .col-right {
          padding-left: 0px;
          margin-left: -25px;
        }
      }
    }
  }

  .actions {
    font-size: 0.75rem;
    font-weight: 400;
    letter-spacing: -0.18px;
    line-height: 30px;

    a {
      text-decoration: underline;
      color: $salesflow-font-dark;
    }

    .profile-detail {
      margin-bottom: 10px;
      color: $gray-light;
      font-family: Montserrat;
      font-size: 0.75rem;
      letter-spacing: -0.18px;
      line-height: 18px;
      font-weight: 400;

      strong {
        margin-top: 6px;
        color: $salesflow-font-dark;
        font-weight: 700;
        font-style: normal;
        display: block;

        .editable {
          display: block;

          .editable-click {
            color: $salesflow-font-dark;
            font-weight: 700 !important;
            font-style: normal !important;
          }
        }
      }

      table {
        tr {
          word-break: break-word;
          overflow-wrap: break-word;

          td {
            padding-bottom: 32px;
            vertical-align: top;
            color: $salesflow-font-gray;
            font-size: 0.75rem;
            line-height: 125%;
            font-weight: 400;
          }

          td:first-child {
            padding-right: 6px;
          }
        }
      }

      .editable {
        margin: 0px;
      }
    }
  }

  .content {
    font-weight: 400;
    line-height: 150%;
    color: $salesflow-font-dark;

    .title {
      margin: 0;
      font-size: 1.75rem;
    }

    .contact-info {
      color: $gray-dark;
      font-size: 0.875rem;
      margin-bottom: 4px;
    }

    .profile-name {
      display: flex;
      align-items: center;

      & > :last-child {
        margin-bottom: 9px;
      }
    }
  }

  .search-model {
    #search-model {
      padding: 11px 20px 0px !important;
    }
  }

  .card {
    margin-top: 36px;
    background: transparent;
  }

  .btn {
    outline: none;
    box-shadow: none;
  }

  .pipeline-options {
    padding: 10px;
  }

  .dropdown-submenu {
    position: relative;
  }

  .scroll {
    margin-right: -25px;
  }

  .nav-tabs {
    background: #F5F5F5 !important;
    border-bottom: 0px;

    .nav-link {
      color: $salesflow-font-gray;
      font-size: 0.75rem;
      font-weight: 600;
      line-height: 150%;
      padding: 12px 16px;
      border-color: transparent;
      background: transparent;
    }

    .nav-link.active {
      background-color: #F5F5F5 !important;
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
      border: 1px solid $salesflow-outline-gray-medium;
      border-bottom: 0px;
      color: $salesflow-primary;
    }
  }

  #funnel-picker-section {
    margin-right: 40px;

    .carousel-container {
      overflow-x: auto;
      scroll-behavior: smooth;
      display: flex;
      flex-grow: 1;
      gap: 4px;
    }
  
    /* Remove a scrollbar do Webkit */
    .carousel-container::-webkit-scrollbar {
      display: none;
    }
  
    .stage-item {
      flex: 0 0 auto;
    }

    .carousel-arrow {
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 20px;
      padding: 10px;
      display: flex;
      align-items: center;
    }
  
    .carousel-arrow.left {
      margin-right: 5px;
    }

    .carousel-arrow.right {
      margin-left: 0px;
    }
  }
}

@media (max-width: 1300px) {
  #deal-modal {
    .move-to-dropdown {
      .dropdown-menu {
        .dropdown-menu.user-options {
          top: 55px !important;
          left: 10px !important;
          right: 0px !important;
        }
      }
    }
  }
}

.container-delete-lead {
  .swal2-modal {
    .container-basic {
      width: 222px !important;
    }
  }
  .swal2-html-container {
    margin-top: 8px !important;
  }
  .swal2-btn-cancel-transparent {
    text-decoration: none !important;
  }
}

.label-hot {
  color: #FF3B30 !important;
}

.label-cold {
  color: #0C81ED !important;
}

.label-warm {
  color: #FF9900 !important;
}

.button-hot:hover {
  background-color: #FFD9D9;
  border: none;
  transition: background-color 0.5s ease;
}

.button-warm:hover {
  background-color: #FFECCF;
  border: none;
  transition: background-color 0.5s ease;
}

.button-cold:hover {
  background-color: #E5F1FF;
  border: none;
  transition: background-color 0.5s ease;
}

.label-temperature {
  margin: 0;
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.63px;
  text-align: left;
  cursor: pointer;
}

.button-temperature {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 100px;
  height: 32px;
  padding: 8.5px 14px;
  border-radius: 8px;
  border: 1px solid #D1D1D1;
  background: #FFFFFF;
  margin-left: auto;
  margin-right: 0px;
  margin-bottom:63px;
}

.col-11-5 {
  flex: 0 0 92% !important;
  max-width: 92% !important;
}

.left-800 {
  left: 800px !important;
}

.z-index-1000 {
  z-index: 1000 !important;
}

.left-0 {
  left: 0px !important;
}

.w-fit-content {
  width: fit-content !important;
}

.button-hover-custom {
  transition: all 0.65s ease;
  position: relative;
}

.button-hover-custom:hover {
  background-color: #5F33FF !important;
  color: white !important;
  min-width: 150px !important;
  gap: 10px !important;
  padding-left: 24px !important;
  justify-content: start !important;
}

#modal-sidebar .btn-switch {
  display: flex;
  width: 104px;
  padding: 10px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 8px;
  color: #71767D;
  background: #FFFFFF;
  font-size: 12px;
  font-weight: 500;
  line-height: 130%;
}

#modal-sidebar .btn-switch.active {
  background: #8869FD;
  color: #FFF;
}

#modal-sidebar .btn-switch.active:hover {
  background: #8869FD;
  color: #FFF;
}

#modal-sidebar .btn-switch:hover {
  color: #8869FD;
}

.informations {
  background-color: rgba(153, 75, 254, 0.05);
  border-radius: 8px;
  padding: 24px 11px;
  min-height: 724px;
  width: 210px;
}

.activities {
  background-color: rgba(153, 75, 254, 0.05);
  border-radius: 8px;
  padding: 24px 4px;
  min-height: 714px;
  width: 92%;
}

.btn-calendar {
  color: #7E5DF4;
  font-weight: 700;
}

.btn-calendar:hover {
  color: #7E5DF4;
  text-decoration: none;
}

.tooltip-container {
  position: fixed;
  width: 300px;
  z-index: 999999;
  pointer-events: none;
  transform: translate(2%, 46%);
}

.tooltip-container-informations {
  position: fixed;
  width: 141px;
  white-space: nowrap;
  z-index: 999999;
  pointer-events: none;
  transform: translate(-13%, 144%);
}

.tooltip-arrow {
  width: 0 !important;
  height: 0 !important;
  border-left: 6px solid transparent !important;
  border-right: 6px solid transparent !important;
  border-bottom: 6px solid #000000 !important;
  position: absolute !important;
  top: -6px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
}

.tooltip-content {
  background: #000000;
  color: #E5E7EA;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  border-radius: 8px;
  padding: 12px;
}

.color-white {
  color: #FFFFFF;
}

.weight-500 {
  font-weight: 500;
}

#deal-modal {
  .modal-dialog {
    z-index: 9999;
  }
  
  .modal-content {
    z-index: 9999;
  }
  
  .modal {
    z-index: 9999;
  }
}

.button-temperature.disabled {
  cursor: not-allowed;
}

.stage-tooltip {
  opacity: 1 !important;
  margin-top: 10px;
  transition: none !important;
  pointer-events: none;
}

.stage-tooltip .tooltip-inner {
  padding: 8px 12px;
  align-items: center;
  border-radius: 8px;
  background: #000000;
  color: #FFF;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  max-width: 232px !important;
  transition: none !important;
}

.stage-tooltip .tooltip-arrow {
  left: 104px !important;
  transition: none !important;
}

.bs-tooltip-bottom .arrow::before,
.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  border-bottom-color: #000000 !important;
  transition: none !important;
}

.avatar-size {
  min-width: 128px;
  min-height: 128px;
}
</style>
